import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

const MenuGroup = styled.div`
  display: flex;
`;

const MenuItem = styled.div`
  padding: 11px 13px;
  font-size: 12px;
  font-weight: 600;
  color: #5d6ef8;
  cursor: pointer;
  width: 144px;
  cursor: pointer;
  text-transform: uppercase;
  text-align: center;
`;

const Slider = styled.div<{ left: number }>`
  width: 144px;
  height: 4px;
  background: #dbdce4;
  position: absolute;
  bottom: -2px;
  left: 0px;
  border-radius: 25px;
  left: ${(props) => props.left}px;
  transition: all 0.2s;
`;

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background: #ecedf7;
`;

export type OptionKey = string | number;

export type Option = {
  text: string;
  value: OptionKey;
};

type Props = {
  options: Option[];
  selected?: OptionKey;
  onChange?: (selected: Option) => void;
};

function MenuSlider({
  options,
  selected,
  onChange = (sel: Option) => {},
}: Props) {
  // Find the index of the selected option;
  const selectedIndex = options.findIndex(
    (option) => option.value === selected
  );

  return (
    <Container>
      <MenuGroup>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => {
              onChange(option);
            }}
          >
            {option.text}
          </MenuItem>
        ))}
      </MenuGroup>
      <Bar />
      <Slider left={selectedIndex * 144} />
    </Container>
  );
}

export default MenuSlider;
